import api from '../api'

function getUserId() {
  try {
    const info = JSON.parse(localStorage.getItem('infoUser') || '{}')
    return info.id || null
  } catch { return null }
}

export default {
  namespaced: true,
  state: {
    sections: [],
    progress: [],
    loaded: false,
  },
  getters: {
    getSections: s => s.sections,
    getProgress: s => s.progress,
    isLoaded: s => s.loaded,
    isSectionCompleted: s => key => s.progress.includes(key),
  },
  mutations: {
    SET_SECTIONS(state, sections) { state.sections = sections },
    SET_PROGRESS(state, progress) { state.progress = progress },
    SET_LOADED(state, v) { state.loaded = v },
    ADD_COMPLETED(state, key) { if (!state.progress.includes(key)) state.progress.push(key) },
  },
  actions: {
    async fetchTutorials({ commit }) {
      try {
        const res = await api.get('tutorial/sections')
        commit('SET_SECTIONS', res.data || [])
        commit('SET_LOADED', true)
      } catch (e) { console.error('[Tutorial] fetch error:', e) }
    },
    async fetchProgress({ commit }) {
      try {
        const userId = getUserId()
        if (!userId) return
        const res = await api.get('tutorial/progress?user_id=' + userId)
        commit('SET_PROGRESS', res.data || [])
      } catch (e) { console.error('[Tutorial] progress error:', e) }
    },
    async markComplete({ commit }, sectionKey) {
      // Guardar local INMEDIATAMENTE para que no se repita
      commit('ADD_COMPLETED', sectionKey)
      try {
        const userId = getUserId()
        if (!userId) return
        await api.post('tutorial/complete', { user_id: userId, section_key: sectionKey })
      } catch (e) { console.error('[Tutorial] complete error:', e) }
    },
    async resetProgress({ commit }) {
      try {
        const userId = getUserId()
        if (!userId) return
        await api.post('tutorial/reset', { user_id: userId })
        commit('SET_PROGRESS', [])
      } catch (e) { console.error('[Tutorial] reset error:', e) }
    },
  },
}
